import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { Container, Image, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import LFlogo from '../../assets/leanfitt_pro.png';
import { hubSignOut } from '../../utils/signOut';
import { fetchMaintenanceConfig, DEFAULT_MAINTENANCE_CONFIG } from '../../utils/maintenance';

/**
 * What everyone outside the whitelist sees while maintenance mode is on.
 *
 * `config` is passed in by MaintenanceGate (which has already loaded it). Mounted directly on
 * /maintenance it loads its own copy, so a super admin can preview the live message.
 */
const MaintenancePage = ({ config: configProp, email }) => {
  const [config, setConfig] = useState(configProp || null);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    if (configProp) {
      setConfig(configProp);
      return;
    }
    fetchMaintenanceConfig()
      .then(setConfig)
      .catch(() => setConfig(DEFAULT_MAINTENANCE_CONFIG));
  }, [configProp]);

  // Only offer sign-out to someone who actually has a session. Otherwise the button reappears after
  // signing out — sign-out clears the tokens and returns here unauthenticated — which reads as a loop.
  useEffect(() => {
    let active = true;
    Auth.currentAuthenticatedUser()
      .then(() => { if (active) setIsAuthed(true); })
      .catch(() => { if (active) setIsAuthed(false); });
    return () => { active = false; };
  }, []);

  if (!config) {
    return (
      <Container className="min-vh-100 d-flex justify-content-center align-items-center">
        <Spinner animation="border" role="status" />
      </Container>
    );
  }

  return (
    <Container
      fluid
      className="p-0 min-vh-100 d-flex flex-column justify-content-center align-items-center"
      style={{ background: '#f8f9fa' }}
    >
      <div
        className="text-center"
        style={{
          background: 'white',
          padding: '2.5rem',
          borderRadius: '12px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          maxWidth: '520px',
          width: '100%'
        }}
      >
        <Image src={LFlogo} alt="LeanFITT Logo" style={{ maxWidth: '160px', marginBottom: '1.5rem' }} />
        <div className="mb-3" style={{ fontSize: '2rem', color: '#007bff' }}>
          <FontAwesomeIcon icon={faScrewdriverWrench} />
        </div>
        <h2 className="mb-3" style={{ color: '#333' }}>{config.title}</h2>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>{config.message}</p>
        {email && (
          <p className="text-muted mb-0" style={{ fontSize: '0.8rem' }}>
            Signed in as {email}
          </p>
        )}
        {isAuthed && (
          <Button variant="outline-secondary" size="sm" className="mt-3" onClick={hubSignOut}>
            Sign out
          </Button>
        )}
      </div>
    </Container>
  );
};

export default MaintenancePage;
